import React from 'react';
import './TopButton.css';

function ButtonGroup(props) {
  const { setActiveButton, activeButton } = props;

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber);
  };

  return (
    <div className="button-group">
      <button
        className={`button ${activeButton === 1 ? 'active' : ''}`}
        onClick={() => handleButtonClick(1)}
      >
        Kombinieren
      </button>
      <button
        className={`button ${activeButton === 2 ? 'active' : ''}`}
        onClick={() => handleButtonClick(2)}
      >
        Info
      </button>
    </div>
  );
}

export default ButtonGroup;
